// import Cookies from 'js-cookie'
import axios from 'axios';
import router from '@/router.js'
import store from '@/store/index.js'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000, // 请求超时时间
  /*headers:{
    s:store.state.app.session
  }*/
  withCredentials:true
});
// request拦截器
service.interceptors.request.use(config => {
    //config.headers.s = store.state.app.session
    /*Indicator.open({
      spinnerType: 'double-bounce'
    })*/
  // Do something before request is sent
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(
  response => {
    //Indicator.close()
    if (response.data.errorCode && response.data.errorCode == 410) {
      /*const state = router.app.$route.query.state || 'home'
      const getSessionUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww56ad1be2c6c94dd2&redirect_uri=http://localtax.gzbige.com/redirect.html&response_type=code&scope=snsapi_userinfo&agentid=1000012&state=${state}#wechat_redirect`
      console.log(getSessionUrl)
      Cookies.remove('session')
      window.location.replace(getSessionUrl)*/
    }else if (!response.data.success){
     alert(response.data.errorMsg)
      return Promise.reject(response.data);
    }
    return response.data.model
  },
  error => {
    //Indicator.close()
    console.log('err' + error); // for debug
   // MessageBox.alert('获取数据失败，请刷新重试')
    return Promise.reject(error);
  }
)

export default service;
